/*
 * File: Home.tsx
 * Project: rosita
 * -----
 * Last Modified: 21 Feb 2022 12:17:12 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Row, Space } from 'antd';
import { ControlFilters, DeploymentsGrid } from 'components/Search';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { useLocation, useNavigate } from 'react-router-dom';

const styles: InlineStylesModel = {
  container: {
    display: 'flex'
  },
  controlsContainer: {
    display: 'flex',
    flex: 1
  },
  searchRow: {
    padding: '20px 10px',
    backgroundColor: 'white'
  },
  searchSalesOrderHeadline: {
    fontSize: '17px'
    // marginBottom: 10
  },
  divider: {
    margin: '9px 0px'
  }
};

export const SearchPage = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const isRecoverPage = location.pathname.includes('recover');

  const handleNavigateToRecoverPage = (): void => {
    navigate('/recover');
  };
  const handleNavigateHome = (): void => {
    navigate('/');
  };

  return (
    <Space direction="vertical" style={styles.container}>
      <Row style={styles.searchSalesOrderHeadline} align="middle" justify="space-between">
        <Col>{location.pathname.includes('recover') ? 'Search Sparing Requests - Recycle Bin' : 'Search Sparing Requests'}</Col>
        <Col>
          {!isRecoverPage ? (
            <Button onClick={handleNavigateToRecoverPage} icon={<DeleteOutlined />}>
              Recycle Bin
            </Button>
          ) : (
            <Button onClick={handleNavigateHome}>Back to Sparing Requests</Button>
          )}
        </Col>
      </Row>
      <Row style={styles.controlsContainer}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Col style={{ background: 'white', padding: '16px' }} xs={24}>
            <ControlFilters />
          </Col>
          <Col span={24}>
            <Divider style={styles.divider} />
            <DeploymentsGrid />
          </Col>
        </Space>
      </Row>
    </Space>
  );
};
